import { useQuery } from '@tanstack/react-query';
import { apiRequests } from '../../shared/api/apiRequests.js';
import { useEffect, useState } from 'react';
import { useRoutes, useSearchParams } from 'react-router-dom';
import { findNestedObject } from '../../shared/utils/findNestedParent.js';
import { axiosInstance } from '../../shared/api/axiosInstance.js';

const LanguageContentPage = () => {
  const { isPending, error, data } = useQuery({
    queryKey: ['getLanguageLocalizations'],
    queryFn: () => apiRequests.languages.getLocalizations(),
    staleTime: Infinity,
  });
  const [searchParams, setSearchParams] = useSearchParams();
  const [structure, setStructure] = useState(null);
  const [locales, setLocales] = useState(null);
  const [values, setValues] = useState({});

  const handleUpdate = () => {
    const arr = Object.keys(values).filter((i) => values[i] !== '');
    const queries = arr.map((i) => {
      return axiosInstance.post(
        `/${structure.crtUpdController}${structure.crtUpdMethod.replace('languageId=0', `languageId=${1}`)}`,
        {
          [i]: values[i],
          Id: locales.id,
        },
      );
    });
    Promise.all(queries);
  };

  useEffect(() => {
    if (data) {
      const pathToValues = searchParams.get('r').split(',');
      const parent = data.find((i) => i.title === pathToValues[0]);
      pathToValues.shift();
      const element = findNestedObject(parent, pathToValues);
      axiosInstance
        .get(
          `${import.meta.env.VITE_API_URL}/${element.getController}${element.getMethod.replace('languageId=0', `languageId=1`)}`,
        )
        .then((res) => {
          setLocales(res);
          let valuesOfLocales = {};
          element.objectStructure.forEach((i) => {
            valuesOfLocales[i.clientFieldName] = '';
          });
          setValues(valuesOfLocales);
          setStructure(element);
        });
    }
  }, [data]);

  return (
    <form action="" method="post" encType="multipart/form-data">
      <div className="page-content mb-3">
        {structure &&
          locales &&
          structure.objectStructure.map((i) => (
            <div key={i.jsonName} className="row">
              <div className="col-md-6">
                <div className="mb-3">
                  <label htmlFor="name" className="form-label">
                    {i.clientFieldName}
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="name"
                    placeholder="Оригинальное выражение"
                    value={
                      locales[String(i.jsonName[0]).toLowerCase() + String(i.jsonName).slice(1)]
                    }
                    disabled
                  />
                </div>
              </div>

              <div className="col-md-6">
                <div className="mb-3">
                  <label htmlFor="name" className="form-label">
                    Перевод
                  </label>
                  <input
                    onChange={(e) =>
                      setValues((prev) => ({ ...prev, [i.clientFieldName]: e.target.value }))
                    }
                    type="text"
                    value={values[i.clientFieldName]}
                    className="form-control"
                    id="name"
                    placeholder="Перевод слова"
                  />
                </div>
              </div>
            </div>
          ))}
      </div>

      <div onClick={handleUpdate} className="button-content button-right">
        <a className="at-btn at-btn-medium">Создать</a>
      </div>
    </form>
  );
};

export default LanguageContentPage;
